import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Subscriber } from '../../Subscriber';
import './MunicipalityLinkTitle.scss';
export const MunicipalityLinkTitle = ({ className, municipality, currentYear, mostRecentYear }) => {
    const clsx = [
        'municipality-link-title',
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    const namePostfix = !!currentYear
        ? `, `
        : _jsxs(_Fragment, { children: [" ", _jsx("span", { children: municipality === null || municipality === void 0 ? void 0 : municipality.kommune_benevnelse.toLocaleLowerCase() })] });
    const title = municipality
        ? _jsxs(_Fragment, { children: [_jsx("span", { children: municipality.kommune_navn }), namePostfix, !!currentYear
                    ? _jsx("span", { children: mostRecentYear === currentYear
                            ? `nyeste år`
                            : `${currentYear}-data` })
                    : null] })
        : null;
    return (_jsx("h2", { className: clsx, children: _jsxs(Subscriber, { children: [_jsx(Subscriber.Eligible, { children: municipality
                        ? _jsx("a", { href: `#kommuner/${municipality.kommune_knr}`, title: `Barometerforsiden for ${municipality.kommune_navn} ${municipality.kommune_benevnelse}`, children: title })
                        : null }), _jsx(Subscriber.NotEligible, { children: title })] }) }));
};
